var module = angular.module('main.resellerorder');

module.component('createResellerorderDeliveryDateVariants', {
    templateUrl: 'main/resellerorder/resellerorderfulfillment/createfulfillment/components/DeliveryDateDialog/createDeliveryDate.cmp.tpl.html',
    bindings: {
        selectedProduct: '<',
        selectedWarehouse: '<',
        minimumAvailableStock: '<',
        onAppliedFulfillment: '&'
    },
    controllerAs: 'vm',
    controller: componentController  
});

// @ngInject
function componentController($scope, $state, $window, $translate, ResellerOrdersApiService, loadSpinnerService, confirmationDialogService, ToasterService) {
    var vm = this;
    var date = moment().format('L');

    //Properties
    vm.deliveryDate = new Date();
    vm.allDeliveryDate = new Date();
    vm.IsChecked = false;
    vm.lineItems = [];
    vm.displayItems = [];
    
    //Methods 
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.applyDeliveryDate = applyDeliveryDate;
    vm.goToOrder = goToOrder;
    vm.quantity = getQuantity;

    function onInit() {
        activate();  
        $scope.$watch(function() { return vm.selectedProduct.variants; }, function(variants) {
        vm.lineItems = getLineItems();
        vm.displayItems = displayLineItems();

        }); 
    }

    function onChanges() {
    }

    function getLineItems(){
        var lineItems = [];
        var newItem = {};
        var date = moment();
        _.forEach(vm.selectedProduct.variants, function (ordVar) {
            _.forEach(ordVar.lineItems, function (li) {
                if(vm.IsChecked === true){
                    date = moment(vm.allDeliveryDate).format('L');
                    newItem = {
                        articleId: vm.selectedProduct.articleId,
                        variantDetail1Id: vm.selectedProduct.variantDetail1Id,
                        orderId:ordVar.orderId,
                        lineItemId: li.lineItemId,
                        orderNumber: ordVar.orderNumber,
                        resellerName: ordVar.resellerName,
                        resellerPriority: ordVar.resellerPriority,
                        deliveryDate: date,
                        quantity: li.quantity,  
                        tenantName: vm.selectedProduct.tenantName      
                    };
                }
                else {
                    date = moment(li.deliveryDate).format('L');
                    newItem = {
                        articleId: vm.selectedProduct.articleId,
                        variantDetail1Id: vm.selectedProduct.variantDetail1Id,
                        orderId:ordVar.orderId,
                        lineItemId: li.lineItemId,
                        orderNumber: ordVar.orderNumber,
                        resellerName: ordVar.resellerName,
                        resellerPriority: ordVar.resellerPriority,
                        deliveryDate: li.plannedDeliverydate,
                        quantity: li.quantity,  
                        tenantName: vm.selectedProduct.tenantName       
                    };
                }
                lineItems.push(newItem);
               
            });
        });
        return lineItems;
    }

    function displayLineItems(){
        var displayItem = {};
        var displayItems = [];
        var result = [];
        var orderNum = '';
        
        _.forEach(vm.lineItems, function(item){
            displayItem = {
                articleId: item.articleId,
                variantDetail1Id: item.variantDetail1Id,
                orderId:item.orderId,
                lineItemId:item.lineItemId,
                orderNumber: item.orderNumber,
                resellerName: item.resellerName,
                resellerPriority: item.resellerPriority,
                deliveryDate: item.deliveryDate,
                quantity: item.quantity,  
                tenantName: item.tenantName       
            };
            displayItems.push(displayItem);
        });
        displayItems = totalQuantityPerOrder(displayItems);
        _.forEach(displayItems, function(di){

            if(di.orderNumber + '' !== orderNum){
                result.push(di);
                orderNum = di.orderNumber; 
            }
        });
        return result;
    }
    function totalQuantityPerOrder(displayItemList){
        _.forEach(displayItemList, function(di){
            
            di.quantity = totalQuantityFunc(displayItemList,di.orderNumber);
            
        });
        return displayItemList;
    }
    function totalQuantityFunc(displayItemList,orderNumber){
        var totalQuantity = 0;
        _.forEach(displayItemList, function(di){
            if(di.orderNumber === orderNumber){
                totalQuantity += di.quantity; 
            }          
        });
        return totalQuantity;
    }

    function getQuantity(variant){
        _.forEach(variant.lineItems, function (li) {
            var newItem = {             
                quantity: li.quantity,
            };
        });
    }

    function goToOrder(orderId) {
        var url = $state.href('resellerorder.resellerorderview', {orderId: orderId});
        $window.open(url,'_blank');
    }

    function activate() {
        loadFulfillableOrders();
    }

    function applyDeliveryDate() {
        var newItem = {};
        var date = moment();
        confirmationDialogService.showDialog($translate.instant('resellerorder.confirmApplyDeliveryDate'), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                var itemsDeliveryDate = { ItemIdsAndDates: [] };
                _.forEach(vm.displayItems, function (di) {                   
                    if(vm.IsChecked === true){
                        date = moment(vm.allDeliveryDate).format('L');
                        newItem = {
                            articleId: di.articleId, 
                            variantDetail1Id: di.variantDetail1Id,
                            orderId: di.orderId,
                            lineItemId:di.lineItemId,
                            deliveryDate: date 
                        };
                    }
                    else {
                        date = moment(di.deliveryDate).format('L');
                        newItem = {
                            articleId: di.articleId, 
                            variantDetail1Id: di.variantDetail1Id,
                            orderId: di.orderId,
                            lineItemId:di.lineItemId,
                            deliveryDate:date    
                        };
                    }
                    itemsDeliveryDate.ItemIdsAndDates.push(newItem);
                });

                ResellerOrdersApiService.setVariantFufillmentDeliveryDate(itemsDeliveryDate).then(function(response) {
                    vm.onAppliedFulfillment();
                }, function(error) {
                    ToasterService.showError(error.message);
                });
            }
        });
    }

    function loadFulfillableOrders() {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getFulfillableOrders(vm.selectedWarehouse.id, vm.minimumAvailableStock, vm.selectedProduct.articleId, vm.selectedProduct.variantDetail1Id).then(function (response) {
            vm.selectedProduct.variants = response.data.orderVariants;
            vm.selectedProduct.variantNames = [];

            _.sortBy(vm.selectedProduct.variants, 'orderNumber');
            _.forEach(vm.selectedProduct.variants, function (ordVar) {
                ordVar.sumFulfillableQuantity = 0;
                ordVar.sumQuantity = 0;
                ordVar.keepRemainder = true;

                _.sortBy(ordVar.lineItems, 'variant2SortOrder');
                _.forEach(ordVar.lineItems, function (li) {
                    if (!vm.selectedProduct.variantNames) { vm.selectedProduct.variantNames = []; }
                    if (vm.selectedProduct.variantNames.indexOf(li.variant2DetailName) === -1) {
                        vm.selectedProduct.variantNames.push(li.variant2DetailName);
                    }
                    ordVar.sumFulfillableQuantity += li.fulfillableQuantity;
                    ordVar.sumQuantity += li.quantity;
                });
            });
        }, function (error) {
            console.log(error);
        }).then(function () {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

}
